import React, { useState } from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { ReorderModal } from "../../../../boxes/ReorderModal/ReorderModal";
import { useClinics } from "./hooks/useClinics";
import { useSaveClinicOrder } from "./hooks/useSaveClinicOrder";

export function ClinicObOrder() {
    const { tCommon } = useAppTranslation.Common();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { clinics, isClinicsLoading } = useClinics();
    const { save, isSaving } = useSaveClinicOrder({
        onSuccess: () => {
            setIsModalOpen(false);
        }
    });

    return (
        <>
            <button
                className="easy-link no-padding m-l-10"
                onClick={() => setIsModalOpen(true)}
            >
                {tCommon("label.obOrder")}
            </button>
            {isModalOpen && (
                <ReorderModal
                    isLoading={isClinicsLoading}
                    isSaving={isSaving}
                    isOpen={isModalOpen}
                    data={clinics}
                    onClose={() => setIsModalOpen(false)}
                    title={tCommon("label.obOrder")}
                    onSave={save}
                />
            )}
        </>
    );
} 